/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_ContentInputs */

const vi_expense_sync_content = /** @type {(inputs: Expense_Sync_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung chuyển khoản`)
};

/**

* @param {Expense_Sync_ContentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_content = /** @type {((inputs?: Expense_Sync_ContentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_ContentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_content(inputs)
});